<template>
  <ActListBox :api="postActivityList" type="7" :title="$t('add.predict')" />
</template>
<script>
import { postActivityList } from '@/api/user'
import ActListBox from '@/components/ActListBox.vue'

export default {
  name: 'UserActList',
  components: { ActListBox },
  watch: {
    '$i18n.locale'() {
      this.init()
    }
  },
  data() {
    return {
      postActivityList,
      list: null
    }
  },
  created() {
    this.init()
  },
  methods: {
    init() {
      postActivityList().then((res) => {
        this.list = res.data.lists.map((item) => {
          item.status = 1
          item.statusName = this.$t('inprogress')
          return item
        })
      })
    },
    handleActivity(item) {
      this.handleRoute('/user/activity', item)
    },
    handleBack() {
      this.$router.back()
    },
    handleRoute(path, item) {
      if (item) {
        this.$router.push({ path: path, query: { rec_code: item.rec_code } })
      } else {
        this.$router.push({ path: path })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/user/actlist.vue